import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
import generateUtilityClass from '@mui/utils/generateUtilityClass';
export function getTableHeadUtilityClass(slot) {
  return generateUtilityClass('MuiTableHead', slot);
}
const tableHeadClasses = generateUtilityClasses('MuiTableHead', ['root']);
export default tableHeadClasses;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/TableHead/tableHeadClasses.js
// module id = 535
// module chunks = 22